import memoize from 'fast-memoize';
import { filtersSelectedLocationType } from 'Interfaces/FiltersMenuInterface';

export const isSelectedFn = (selected: filtersSelectedLocationType[], key: string) => {
  return selected.find(s => `${s.key}` === `${key}`);
};

export const isSelected = memoize(isSelectedFn);
